import React from "react";
import PropTypes, { any, func, objectOf } from "prop-types";
import { connect } from "react-redux";
import InputField from "components/InputField/InputField";
import SelectField from "components/InputField/SelectField";
import FileField from "components/InputField/FileField";
import NewQuiz from "components/Admin/Quiz/NewQuiz";
import AddSpeaker from "components/Admin/Speaker/AddSpeaker";
import DateTimeField from "components/InputField/DateTimeField";
import constants from "constants";
import _ from "lodash";
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Select from "react-select";
import pdfPlaceholder from "../../../../assets/img/pdfPlaceholder.png";
import Icon from "material-ui/Icon";

const { CPD_STATUSES, REF_TYPES } = constants;

const labels = {
  faculty: "faculty",
  price: "Price &#8364;",
  webinar_title: "Webinar topic",
  number_cpd_points: "Number of CPD points",
  vimeo_url: "Vimeo video uid",
  zoom_uid: " Zoom webinar / meeting id",
  status: "Status",
  cpd_points: "Type of CPD points",
  join_url: "Join URL",
  cpd_status: "CPD status",
  partnerships_ids: "Partner",
  int_cpd_points: "Number of Int CPD points",
  ext_cpd_points: "Number of Ext CPD points",
  icgp_ref: "ICGP Ref #",
  rcpi_ref: "RCPI Ref #",
  ipna_ref: "IGPNEA Ref #",
  ref_type: "Ref Type",
  discipline: "Discipline",
  gms_study_days: "GMS Study Leave",
  group_id: "Select group",
  audio_link: "Audio link",
  sponsorship_value: "Enter Sponsorship value €",
  zoom_account: "Zoom Account",
  duration: "Duration",
};

const statuses = [
  { value: "published", label: "Published" },
  { value: "unpublished", label: "Unpublished" },
];
const refType = [
  { value: REF_TYPES.ICGP, label: "ICGP" },
  { value: REF_TYPES.RCPI, label: "RCPI" },
  { value: REF_TYPES.FSEM, label: "FSEM" },
  { value: REF_TYPES.IPNA, label: "IGPNEA" },
  {
    value: REF_TYPES.CERTIFICATE_OF_PARTICIPATION,
    label: "Certificate of Participation",
  },
  {
    value: REF_TYPES.NMBI,
    label: "NMBI CPD Certificate",
  },
];

const cpdPoints = [
  { value: "external", label: "External" },
  { value: "internal", label: "Internal" },
  { value: "both", label: "Both" },
];

const cpdStatus = [
  { value: CPD_STATUSES.granted, label: "Granted" },
  { value: CPD_STATUSES.applied_for, label: "Applied for" },
  { value: CPD_STATUSES.not_applicable, label: "Not applicable" },
];

const onlyConsultantAndOrNCHD = [];

const hideMore = (roles, counties, onConsultantOrHD) => {
  let matches = _.intersection(roles, onlyConsultantAndOrNCHD);
  if (roles && roles.length && roles.length === matches.length) {
    const selectedCounties = counties.map((county) => county.value);
    onConsultantOrHD(selectedCounties);
    return true;
  } else {
    return false;
  }
};

const getCertificateRefFieldName = (certificateRef) => {
  if (certificateRef === REF_TYPES.ICGP) {
    return "icgp_ref";
  }
  if (certificateRef === REF_TYPES.RCPI) {
    return "rcpi_ref";
  }
  if (certificateRef === REF_TYPES.IPNA) {
    return "ipna_ref";
  }
};

const EditWebinarForm = ({
  webinar = {},
  errors = {},
  onFieldChange,
  onQuizAdd,
  onQuizChange,
  onQuizRemove,
  onDateChange,
  onSubmit,
  cpdPointsFields,
  onCpdPointsChange,
  onSponsoredChange,
  onCpdTypeChange,
  onCertificateRefChange,
  onSponsorUsersChange,
  sponsorUsersOptions,
  counties,
  onConsultantOrHD,
  onWebinarTypeChange,
  onExpertAdd,
  onExpertRemove,
  onExpertChange,
  goToAddUsersPage,
  showUsersModal,
  attachment,
  attachment_url,
  onAttachmentChange,
  attachmentType,
  ppt_document_url,
  onPptDocumentChange,
  onSelectChangeDiscipline,
  search_disciplines,
  onSelectChangeDisciplineSearch,
  disciplines = [],
  onEventWebinarChange,
  onGenerateQRChange,
  onDragEnd,
  role,
  studygroups,
  zoomAccounts,
  onSessionAdd,
  onSessionRemove,
  onSessionChange,
  onShowSponsorTitle,
  sponsorsOptions,
  onSponsorChange,
}) => {
  const hideMoreValue = hideMore(
    webinar.user_types,
    counties,
    onConsultantOrHD
  );

  const isCertificateOfParticipation =
    webinar.ref_type === REF_TYPES.CERTIFICATE_OF_PARTICIPATION;

  const isNMBI = webinar.ref_type === REF_TYPES.NMBI;

  const isCustomCertificate = isCertificateOfParticipation;

  return (
    <div className="container_records">
      <div className="add_webinar new-webinar">
        <h3>Webinar #{webinar.id}</h3>
        <div className="add_webinar_bg row">
          <form className="col s12">
            {/* <div className="block-radiogroup">
              <FormControl className="wimin-webinar">
                Add breakout rooms
                <RadioGroup
                  aria-label="Add breakout rooms"
                  label="Add breakout rooms"
                  value={webinar.for_event}
                  onChange={onEventWebinarChange}
                  row
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
              <FormControl className="wimin-webinar">
                QR Code
                <RadioGroup
                  aria-label="QR Code"
                  label="QR Code"
                  value={webinar.generate_qrcode}
                  onChange={onGenerateQRChange}
                  row
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div> */}
            {role === "admin" && (
              <div className="col s12">
                <a className="button_classic-new" onClick={goToAddUsersPage}>
                  Add User
                </a>
              </div>
            )}
            {role === "admin" && (
              <div className="col s12">
                <a className="button_classic-new" onClick={showUsersModal}>
                  Assigned users
                </a>
              </div>
            )}
            <FormControl>
              <RadioGroup
                aria-label="webinar type"
                value={webinar.webinar_type || "online"}
                onChange={onWebinarTypeChange}
                row
              >
                <FormControlLabel
                  value="online"
                  control={<Radio color="primary" />}
                  label="Webinar"
                />
                <FormControlLabel
                  value="recorded"
                  control={<Radio color="primary" />}
                  label="Video recorded"
                />
                <FormControlLabel
                  value="audio"
                  control={<Radio color="primary" />}
                  label="Audio recorded"
                />
              </RadioGroup>
            </FormControl>

            {webinar.webinar_type === "online" && (
              <InputField
                className="col s12"
                label={labels["join_url"]}
                field_name={"join_url"}
                onChange={onFieldChange}
                errors={errors["join_url"]}
                autoComplete="new-password"
                value={webinar.join_url}
              />
            )}

            {webinar.webinar_type === "audio" && role === "admin" && (
              <InputField
                className="coll s12"
                label={labels["audio_link"]}
                field_name="audio_link"
                onChange={onFieldChange}
                errors={errors["audio_link"]}
                autoComplete="new-password"
                value={webinar["audio_link"] || ""}
              />
            )}

            {webinar.webinar_type === "recorded" && role === "admin" && (
              <div>
                <InputField
                  className="coll s12"
                  label={labels["vimeo_url"]}
                  field_name="vimeo_url"
                  onChange={onFieldChange}
                  errors={errors["vimeo_url"]}
                  autoComplete="new-password"
                  value={webinar["vimeo_url"] || ""}
                />
                {webinar.vimeo_url && (
                  <InputField
                    className="coll s12"
                    label={labels["duration"]}
                    field_name="duration"
                    onChange={onFieldChange}
                    errors={errors["duration"]}
                    autoComplete="new-password"
                    value={webinar["duration"] || ""}
                  />
                )}
              </div>
            )}

            {webinar.webinar_type === "online" && role === "admin" && (
              <div>
                <InputField
                  className="coll s12"
                  label={labels["vimeo_url"]}
                  field_name="vimeo_url"
                  onChange={onFieldChange}
                  errors={errors["vimeo_url"]}
                  autoComplete="new-password"
                  value={webinar["vimeo_url"] || ""}
                />
                {webinar.vimeo_url && (
                  <InputField
                    className="coll s12"
                    label={labels["duration"]}
                    field_name="duration"
                    onChange={onFieldChange}
                    errors={errors["duration"]}
                    autoComplete="new-password"
                    value={webinar["duration"] || ""}
                  />
                )}
                <InputField
                  className="coll s12"
                  label={labels["zoom_uid"]}
                  field_name="zoom_uid"
                  onChange={onFieldChange}
                  errors={errors["zoom_uid"]}
                  autoComplete="new-password"
                  value={webinar["zoom_uid"] || ""}
                />
                <InputField
                  className="coll s12"
                  label={labels["audio_link"]}
                  field_name="audio_link"
                  onChange={onFieldChange}
                  errors={errors["audio_link"]}
                  autoComplete="new-password"
                  value={webinar["audio_link"] || ""}
                />
              </div>
            )}

            {webinar.webinar_type === "online" && (
              <DateTimeField
                className="col s12"
                onChange={onDateChange}
                value={webinar.start_date}
                label="Start date"
                field_name="start_date"
                errors={errors["start_date"]}
              />
            )}
            {webinar.webinar_type === "online" && (
              <DateTimeField
                className="col s12"
                onChange={onDateChange}
                value={webinar.end_date}
                label="End date"
                field_name="end_date"
                errors={errors["end_date"]}
              />
            )}
            <InputField
              className="coll s12"
              label={labels["webinar_title"]}
              field_name="webinar_title"
              onChange={onFieldChange}
              errors={errors["webinar_title"]}
              autoComplete="new-password"
              value={webinar["webinar_title"]}
            />
            {search_disciplines.length && (
              <div>
                <div className="col s12">
                  <Select
                    placeholder="Webinar discipline"
                    value={webinar.search_disciplines}
                    onChange={onSelectChangeDisciplineSearch}
                    multi={true}
                    options={search_disciplines.map((discipline) => ({
                      value: discipline.id,
                      label: discipline.title,
                    }))}
                  />
                  <div style={{ color: "red", fontSize: "0.875rem" }}>
                    {(errors.search_disciplines || []).join(". ")}
                  </div>
                </div>
                <div>
                  <a
                    className="false"
                    style={
                      webinar.search_disciplines.length ===
                      search_disciplines.length
                        ? { display: "none", cursor: "pointer" }
                        : { cursor: "pointer" }
                    }
                    onClick={() => {
                      onSelectChangeDisciplineSearch(search_disciplines);
                    }}
                  >
                    Select all
                  </a>
                  &nbsp;
                  <a
                    className="false"
                    style={
                      webinar.search_disciplines.length === 0
                        ? { display: "none", cursor: "pointer" }
                        : { cursor: "pointer" }
                    }
                    onClick={() => {
                      onSelectChangeDisciplineSearch([]);
                    }}
                  >
                    Deselect all
                  </a>
                </div>
              </div>
            )}
            <AddSpeaker
              onChange={onExpertChange}
              onAddElement={onExpertAdd}
              onRemoveElement={onExpertRemove}
              onDragEnd={onDragEnd}
              speakers={webinar.experts_attributes}
            />
            {webinar.webinar_type === "online" && (
              <SelectField
                className="col s12"
                label={labels["zoom_account"]}
                onChange={onFieldChange}
                errors={errors["zoom_account"]}
                field_name="zoom_account"
                value={webinar.zoom_account}
                options={zoomAccounts}
              />
            )}
            <SelectField
              className="col s12"
              label={labels["cpd_status"]}
              onChange={onCpdTypeChange}
              errors={errors["cpd_status"]}
              field_name="cpd_status"
              value={webinar.cpd_status || ""}
              options={cpdStatus}
            />
            {!hideMoreValue &&
              (webinar.cpd_status === CPD_STATUSES.granted ||
                webinar.cpd_status === CPD_STATUSES.applied_for) && (
                <SelectField
                  className="col s12"
                  label={labels["ref_type"]}
                  onChange={onCertificateRefChange}
                  errors={errors["ref_type"]}
                  field_name="ref_type"
                  value={webinar.ref_type}
                  options={refType}
                />
              )}
            {!hideMoreValue &&
              webinar.cpd_status === CPD_STATUSES.granted &&
              webinar.ref_type !== REF_TYPES.FSEM &&
              !isCustomCertificate &&
              !isNMBI && (
                <InputField
                  className="col s12"
                  label={labels[getCertificateRefFieldName(webinar.ref_type)]}
                  field_name={getCertificateRefFieldName(webinar.ref_type)}
                  onChange={onFieldChange}
                  errors={errors[getCertificateRefFieldName(webinar.ref_type)]}
                  value={webinar[getCertificateRefFieldName(webinar.ref_type)]}
                />
              )}
            {!hideMoreValue &&
              webinar.cpd_status === CPD_STATUSES.granted &&
              !isCustomCertificate && (
                <SelectField
                  className="col s12"
                  label={labels["cpd_points"]}
                  onChange={onCpdPointsChange}
                  errors={errors["cpd_points"]}
                  field_name="cpd_points"
                  value={webinar.cpd_points}
                  options={cpdPoints}
                />
              )}
            {!hideMoreValue &&
              !isCustomCertificate &&
              cpdPointsFields.map((field) => (
                <InputField
                  className="col s12"
                  label={labels[field]}
                  field_name={field}
                  onChange={onCpdPointsChange}
                  errors={errors[field]}
                  value={webinar[field]}
                />
              ))}
            {!hideMoreValue &&
              webinar.ref_type === REF_TYPES.ICGP &&
              !isCustomCertificate &&
              !isNMBI && (
                <InputField
                  className="col s12"
                  label={labels["gms_study_days"]}
                  field_name={"gms_study_days"}
                  onChange={onFieldChange}
                  errors={errors["gms_study_days"]}
                  value={webinar["gms_study_days"]}
                />
              )}
            {/* <div className="col s12">
              <FormControl className="wimin-webinar">
                Are you seeking sponsorship
                <RadioGroup
                  value={webinar.is_sponsored}
                  onChange={onSponsoredChange}
                  row
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            {webinar.is_sponsored && (
              <div>
                <div className="col s12">
                  <Select
                    style={{ marginTop: 10 }}
                    options={sponsorUsersOptions}
                    placeholder="Select clients"
                    value={webinar.sponsor_representative_id}
                    onChange={onSponsorUsersChange}
                  />
                  <a
                    className={`${
                      !webinar.sponsor_representative_id && "hide"
                    }`}
                    href="javascript:void(0)"
                    onClick={() => {
                      onFieldChange({
                        target: {
                          name: "sponsor_representative_id",
                          value: [],
                        },
                      });
                    }}
                  >
                    Clear
                  </a>
                </div>
                <InputField
                  className="col s12"
                  label={labels["sponsorship_value"]}
                  field_name={"sponsorship_value"}
                  onChange={onFieldChange}
                  errors={errors["sponsorship_value"]}
                  value={webinar.sponsorship_value}
                />
              </div>
            )} */}
            <div>
              <label
                className="mt-20 button_classic add_attachment_button"
                htmlFor="vebinar_attachment"
              >
                Add Attachment +
              </label>
              <FileField
                className="col s12 vebinar_attachment"
                field_name="vebinar_attachment"
                onChange={(e) => onAttachmentChange(e.target.value)}
                label="File"
              />
              {attachment_url ? (
                <div className="attachment_preview_wrapper">
                  <Icon
                    onClick={() => onAttachmentChange()}
                    className="remove_attachment"
                  >
                    close
                  </Icon>
                  <a
                    className="download_attachment_link"
                    href={attachment_url}
                    target="_blank"
                  >
                    Download attachment
                  </a>
                  <img
                    src={
                      attachment_url.includes("jpg") ||
                      attachment_url.includes("png") ||
                      attachmentType.includes("image")
                        ? attachment_url
                        : pdfPlaceholder
                    }
                    className="attachment_preview"
                  />
                </div>
              ) : null}
            </div>
            <div>
              <div>
                <label
                  className="mt-20 button_classic add_attachment_button"
                  htmlFor="ppt_document"
                >
                  Add ppt document +
                </label>
                <FileField
                  className="col s12 vebinar_attachment"
                  field_name="ppt_document"
                  onChange={(e) => onPptDocumentChange(e.target.value)}
                  label="PPT"
                  accept="application/pdf, .pptx, .ppt, .docx .xls, .xlsx"
                />
                {ppt_document_url ? (
                  <div className="attachment_preview_wrapper">
                    <Icon
                      onClick={() => onPptDocumentChange()}
                      className="remove_attachment"
                    >
                      close
                    </Icon>
                    <a
                      className="download_attachment_link"
                      href={ppt_document_url}
                      target="_blank"
                    >
                      Download attachment
                    </a>
                    <img
                      src={
                        ppt_document_url.includes("jpg") ||
                        ppt_document_url.includes("png") ||
                        attachmentType.includes("image")
                          ? ppt_document_url
                          : pdfPlaceholder
                      }
                      className="attachment_preview"
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <SelectField
              className="col s12"
              label={labels["status"]}
              onChange={onFieldChange}
              errors={errors["status"]}
              field_name="status"
              value={webinar.status}
              options={statuses}
            />

            <div>
              <div className="col s12">
                <Select
                  style={{ marginTop: 10 }}
                  options={sponsorsOptions}
                  placeholder="Select sponsors"
                  value={webinar.sponsor_ids}
                  onChange={onSponsorChange}
                  multi={true}
                />

                <a
                  className={`${!webinar.sponsor_ids && "hide"}`}
                  href="javascript:void(0)"
                  onClick={() => {
                    onFieldChange({
                      target: { name: "sponsor_ids", value: [] },
                    });
                  }}
                >
                  Clear
                </a>
              </div>
            </div>

            <button
              onClick={onSubmit}
              className="button_classic"
              type="button"
              name="button"
            >
              {" "}
              Save
            </button>
          </form>
        </div>
      </div>
      {hideMoreValue ? null : (
        <NewQuiz
          onChange={onQuizChange}
          onAddElement={onQuizAdd}
          onRemoveElement={onQuizRemove}
          quizzes={webinar.spd_quizzes_attributes}
        />
      )}
    </div>
  );
};

EditWebinarForm.defaultProps = {};

EditWebinarForm.propTypes = {
  webinar: objectOf(any),
  errors: objectOf(any),
  onFieldChange: func,
  onQuizAdd: func,
  onSessionAdd: func,
  onQuizChange: func,
  onSessionChange: func,
  onDateChange: func,
  onSponsorChange: func,
  onSubmit: func,
  onQuizRemove: func,
  onSessionRemove: func,
  cpdPointsFields: PropTypes.arr,
  counties: PropTypes.array,
  onWebinarTypeChange: func,
};

const mapStateToProps = (state) => ({
  counties: state.suggestions.county.values,
});

export default connect(mapStateToProps)(EditWebinarForm);



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/Webinar/EditWebinarForm.jsx